module.exports = __webpack_public_path__ + "img/title.7f553321.png";